import {
    GET_INVENTORY_LIST,
    GET_INVENTORY_LIST_SUCCESS,
    GET_INVENTORY_LIST_FAILURE,
    SETS_INVENTORY_EXPORT,
    SETS_INVENTORY_EXPORT_SUCCESS,
    SETS_INVENTORY_EXPORT_FAILURE,
    RESET_SETS_INVENTORY_EXPORT,
} from '../actions';

const initialState = {
    loading: false,
    loadingSetsExport: false,
    data: null,
    exportData: null,
    error: null,
};

const inventoryListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_INVENTORY_LIST:
            return { ...state, loading: true, error: null };
        case GET_INVENTORY_LIST_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_INVENTORY_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SETS_INVENTORY_EXPORT:
            return { ...state, loadingSetsExport: true, exportData: null, error: null };
        case SETS_INVENTORY_EXPORT_SUCCESS:
            return { ...state, loadingSetsExport: false, exportData: action.payload };
        case SETS_INVENTORY_EXPORT_FAILURE:
            return { ...state, loadingSetsExport: false, error: action.payload };
        case RESET_SETS_INVENTORY_EXPORT:
            return { ...state, exportData: null };
        default:
            return state;
    }
};

export default inventoryListReducer;
